// extracted by mini-css-extract-plugin
module.exports = {"reportingPieChart":"reportingDoughnutChart_reportingPieChart__3X0bk","reset":"reportingDoughnutChart_reset__2CkTP","chartWrapper":"reportingDoughnutChart_chartWrapper__YuKid"};